import { render, staticRenderFns } from "./ai-chat.vue?vue&type=template&id=0ef43864&scoped=true&"
import script from "./ai-chat.vue?vue&type=script&lang=js&"
export * from "./ai-chat.vue?vue&type=script&lang=js&"
import style0 from "./ai-chat.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ai-chat.vue?vue&type=style&index=1&id=0ef43864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef43864",
  null
  
)

export default component.exports